import { EssentialFieldNode } from 'routes/essential-workspace/state/model';

export function DebugField(props: EssentialFieldNode) {
  if (!import.meta.env.DEV) {
    return null;
  }

  return (
    <div className="card card-bordering-primary bg-lvl1 p-3 text-secondary h-100 flex-y align-items-center justify-content-center">
      <span>Field not implemented</span>
      <span>
        id: {props.id} | type: {props.type}
      </span>
    </div>
  );
}
